<template>
  <div>
    <Dialog
      :key="notificationFormKey"
      :visible.sync="notificationForm1"
      :style="{ width: '900px', overflowY: 'auto' }"
      header="Notification Settings"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="getReminderEmail">Get task and event reminder emails</label>
          <br />
          <InputSwitch v-model="user.getReminderEmail" />
        </div>
        <div class="p-field p-col">
          <label for="getNotesEmail">Get notes emails</label>
          <br />
          <InputSwitch v-model="user.getNotesEmail" autofocus />
        </div>
        <div
          class="p-field p-col"
          v-if="
            $store.getters['auth/getMyProfile'] &&
              $store.getters['auth/getMyProfile'].role &&
              $store.getters['auth/getMyProfile'].role.roleName &&
              $store.getters['auth/getMyProfile'].role.roleName === 'Admin'
          "
        >
          <label for="getCustApproveEmail">Get customer approval emails</label>
          <br />
          <InputSwitch v-model="user.getCustApproveEmail" autofocus />
        </div>
        <!-- "Create Outlook Event" is not here: switching Outlook on is Admin only (Mohammed
             05/10/2026), on the Admin user screens (UserForm, UserInfo). -->
      </div>

      <template #footer>
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-danger"
          style="width: 100px;"
          @click="close"
        />
        <ProgressSpinner
          v-if="sendingRequest"
          style="width:25px; height:25px; width: 100px;"
          strokeWidth="5"
          fill="#EEEEEE"
          animationDuration=".5s"
        />
        <Button
          v-else
          label="Save"
          icon="pi pi-check"
          class="p-button-success"
          style="width: 100px;"
          @click="save"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import UserService from "@/service/UserService";

import { sendUser } from "../sendRequest";

export default {
  created() {
    this.setupComponent();
  },
  props: {
    notificationForm: {
      required: true,
      type: Boolean
    },
    reloadForm: {
      required: false,
      type: Number
    },
    refreshForm: {
      required: false,
      type: Number
    }
  },
  data: () => ({
    userService: new UserService(),
    submitted: false,
    sendingRequest: false,
    user: {},
    notificationFormKey1: 0
  }),
  computed: {
    notificationFormKey: {
      set(val) {
        this.notificationFormKey1++;
      },
      get() {
        //

        return "userFormKey-" + this.notificationFormKey1.toString();
      }
    },
    notificationForm1: {
      set(val) {
        if (!val) {
          this.close();
        }
      },
      get() {
        return this.notificationForm;
      }
    }
  },
  watch: {
    notificationForm(val) {
      this.notificationFormKey1 = this.notificationFormKey1 + 1;
    },
    reloadForm() {
      this.notificationFormKey1 = this.notificationFormKey1 + 1;
    },
    refreshForm(val) {
      this.setupComponent();
    }
  },
  methods: {
    setupComponent() {
      this.submitted = false;
      this.sendingRequest = false;
      this.user = {};

      this.userService
        .getNotifications()
        .then(data => {
          this.user = data.data;
        })
        .catch(error => {
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "user/getNotifications"'
          });
        });
    },
    close() {
      this.$emit("close");
    },
    save() {
      //
      this.submitted = true;
      this.sendingRequest = true;

      this.userService
        .updateNotifications({
          getReminderEmail: this.user.getReminderEmail,
          getNotesEmail: this.user.getNotesEmail,
          getCustApproveEmail: this.user.getCustApproveEmail
        })
        .then(data => {
          this.setupComponent();
          this.close();
        })
        .catch(_ => {
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: "Failed to update Notification settings"
          });
        });
    }
  }
};
</script>

<style></style>
